/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'checkmark': {
    viewBox: '0 0 32 32',
    data: `<g><path d="M16,1C7.7,1,1,7.7,1,16c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C31,7.7,24.3,1,16,1z M16,29C8.8,29,3,23.2,3,16C3,8.8,8.8,3,16,3c7.2,0,13,5.8,13,13C29,23.2,23.2,29,16,29z"/><path d="M22.2,9.4l-8.4,10.2l-4.2-3.4c-0.4-0.3-1.1-0.3-1.4,0.2c-0.3,0.4-0.3,1.1,0.2,1.4l5.8,4.6l9.6-11.8c0.3-0.4,0.3-1.1-0.1-1.4S22.6,8.9,22.2,9.4z"/></g>`
  }
})
